import { RestClient } from '@libs/rest-client';
import type { SpaceRaw } from '../models';

const SPACE_URL = '/space';

/**
 * Fetch the space the request resolves to (Raw→Model conversion happens in `models`).
 *
 * <p>The server resolves the auto-attached `spaceCode` and falls back to the main space when it is
 * missing or unknown.
 */
async function fetchCurrentSpace(): Promise<SpaceRaw> {
  return await RestClient.fa.get<SpaceRaw>(`${SPACE_URL}/current`);
}

/** 台帳の一覧を Raw のまま取得する（Model への変換は models で行う）。 */
async function fetchSpaces(): Promise<SpaceRaw[]> {
  return await RestClient.fa.get<SpaceRaw[]>(SPACE_URL);
}

/** 台帳を登録する。server は台帳名を `name` で受け取る（`SpaceRegisterVo.name()`）。 */
async function createSpace(spaceName: string) {
  await RestClient.fa.post(SPACE_URL, { name: spaceName });
}

export { createSpace, fetchCurrentSpace, fetchSpaces };
